export class Controller {

    /** @ngInject */
    constructor(AccessRequestsService, Alert, $rootScope, $state) {
        this.AccessRequestsService = AccessRequestsService;
        this.Alert = Alert;
        this.$rootScope = $rootScope;
        this.$state = $state;
    }

    $onInit() {
    }

    accountChanged() {
    }

    approve() {
        this.AccessRequestsService.approveRequest(this.companyId, this.accessRequest.id, this.selectedAccount.id)
            .then(() => {
                this.Alert('success', 'global.messages.operation-successful');
                this.$state.go('^', {}, {reload: '^'})
            });
    }

	goBack() {
		var goToState = this.$rootScope.transition.from();
		var theState = goToState.name;
		if (theState === "") {
			theState = goToState.url;
		}
		this.$state.go(theState);
	}
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/approve/approve-access-request.controller.js